import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';
import {
    List,
    ListItem,
    withStyles,
    ListItemText,
    ListItemAvatar,
    Avatar
} from '@material-ui/core';
import logo from '../../assets/img/logo1.jpg';
import pay3 from '../../assets/images/Frame 6.png';
import pay1 from '../../assets/images/Frame 7.png';
import pay4 from '../../assets/images/44.png';
import pay5 from '../../assets/images/Frame 5.png';
import pay6 from '../../assets/images/Frame 3.png';
import pay7 from '../../assets/images/Frame 2.png';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import footerStyle from 'assets/jss/material-kit-react/components/footerStyle.jsx';
import moment from 'moment';
import withUser from '../HOC/HOCwithUser.jsx';
import { APP_NAME } from '../../utils/config/constants';
import { withTheme } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter, Link } from 'react-router-dom';
import { LocationOn, Call, Email } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category } from '@material-ui/icons';
import NewServiceSuggestionDialog from '../Dialogs/NewServiceSuggestionDialog';
import { Fade, DialogContent, Dialog } from '@material-ui/core';
import fb from '../../assets/images/fb.png';
import tut from '../../assets/images/tut.png';
import insta from '../../assets/images/inta-.png';
import twt from "../../assets/images/new-img/twt.png"
import maestro from "../../assets/images/new-img/maestro.png"
import logowhite from "../../assets/images/new-img/logowhite.png"
import link from "../../assets/images/new-img/link.png"
import linkedin from "../../assets/images/new-img/linkedin.png"

import { FaFacebookF } from "react-icons/fa";

// import FacebookIcon from '@mui/icons-material/Facebook';
// import InstagramIcon from '@mui/icons-material/Instagram';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import XIcon from '@mui/icons-material/X';




let isMounted = false;
class Footer extends Component {
    constructor() {
        super();
        this.state = {
            showServiceDialog: false,
            showBookButton: false,
            providers: [],
            services: [],
            redirect: false,
            providerData: []
        };
    }

    alltask = (item) => {
        this.props.history.push(`/`);
        console.log("sanu", item, '#select_' + item.category.key, '#service_' + item.category.mastercategory_id);
        setTimeout(() => {
            $('#service_' + item.category.mastercategory_id).click();
            $('#select_' + item.category.key).click();
        }, 5)



        // this.setState({
        //     showServiceDialog: true
        // })
    };
    handleCloseServiceDialog = () => {
        this.setState({
            showServiceDialog: false,
            showBookButton: false
        })
    }

    componentDidMount() {
        isMounted = true;
        this.getData();
    }
    getData() {
        if (isMounted) {
            this.props.allProviderListingAction(
                {
                    featured: false,
                    filter: 0,
                    text: '',
                    type: ''
                },
                this.onDone
            );
            this.props.topServiceListAction(this.onServiceDone);
        }
    }
    componentWillUnmount() {
        isMounted = false;
    }


    redirectLink = serviceId => {
        this.props.serviceProviderListAction(
            {
                serviceId: serviceId,
                type: 2
            },
            this.onredirectDone
        );
        this.setState({ clickedServiceId: serviceId });
    };
    onredirectDone = (success, data) => {
        if (success) {
            this.setState({
                providerData: data.data.providerList,
                redirect: true
            });
        }
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ providers: data.data });
        }
    };
    onServiceDone = (success, data) => {

        if (success) {
            this.setState({ services: data.data });
            console.log('hh')
        }
    };
    renderCmsDetail = slug => {
        this.props.history.push(`/page/${slug}`);
    };

    facebook() {
        return (
            <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="25px" height="25px"><path d="M 25 3 C 12.861562 3 3 12.861562 3 25 C 3 36.019135 11.127533 45.138355 21.712891 46.728516 L 22.861328 46.902344 L 22.861328 29.566406 L 17.664062 29.566406 L 17.664062 26.046875 L 22.861328 26.046875 L 22.861328 21.373047 C 22.861328 18.494965 23.551973 16.599417 24.695312 15.410156 C 25.838652 14.220896 27.528004 13.621094 29.878906 13.621094 C 31.758714 13.621094 32.490022 13.734993 33.185547 13.820312 L 33.185547 16.701172 L 30.738281 16.701172 C 29.349697 16.701172 28.210449 17.475903 27.619141 18.507812 C 27.027832 19.539724 26.84375 20.771816 26.84375 22.027344 L 26.84375 26.044922 L 32.966797 26.044922 L 32.421875 29.564453 L 26.84375 29.564453 L 26.84375 46.929688 L 27.978516 46.775391 C 38.71434 45.319366 47 36.126845 47 25 C 47 12.861562 37.138438 3 25 3 z M 25 5 C 36.057562 5 45 13.942438 45 25 C 45 34.729791 38.035799 42.731796 28.84375 44.533203 L 28.84375 31.564453 L 34.136719 31.564453 L 35.298828 24.044922 L 28.84375 24.044922 L 28.84375 22.027344 C 28.84375 20.989871 29.033574 20.060293 29.353516 19.501953 C 29.673457 18.943614 29.981865 18.701172 30.738281 18.701172 L 35.185547 18.701172 L 35.185547 12.009766 L 34.318359 11.892578 C 33.718567 11.811418 32.349197 11.621094 29.878906 11.621094 C 27.175808 11.621094 24.855567 12.357448 23.253906 14.023438 C 21.652246 15.689426 20.861328 18.170128 20.861328 21.373047 L 20.861328 24.046875 L 15.664062 24.046875 L 15.664062 31.566406 L 20.861328 31.566406 L 20.861328 44.470703 C 11.816995 42.554813 5 34.624447 5 25 C 5 13.942438 13.942438 5 25 5 z" /></svg>
        )
    }

    instagram() {
        return (
            <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="24px" height="24px"><path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z" /></svg>
        )
    }

    linkedin() {
        return (
            <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="24px" height="24px"><path d="M 9 4 C 6.2504839 4 4 6.2504839 4 9 L 4 41 C 4 43.749516 6.2504839 46 9 46 L 41 46 C 43.749516 46 46 43.749516 46 41 L 46 9 C 46 6.2504839 43.749516 4 41 4 L 9 4 z M 9 6 L 41 6 C 42.668484 6 44 7.3315161 44 9 L 44 41 C 44 42.668484 42.668484 44 41 44 L 9 44 C 7.3315161 44 6 42.668484 6 41 L 6 9 C 6 7.3315161 7.3315161 6 9 6 z M 14 11.011719 C 12.904779 11.011719 11.919219 11.339079 11.189453 11.953125 C 10.459687 12.567171 10.011719 13.484511 10.011719 14.466797 C 10.011719 16.333977 11.631285 17.789609 13.691406 17.933594 A 0.98809878 0.98809878 0 0 0 13.695312 17.935547 A 0.98809878 0.98809878 0 0 0 14 17.988281 C 16.27301 17.988281 17.988281 16.396083 17.988281 14.466797 A 0.98809878 0.98809878 0 0 0 17.986328 14.414062 C 17.884577 12.513831 16.190443 11.011719 14 11.011719 z M 14 12.988281 C 15.392231 12.988281 15.94197 13.610038 16.001953 14.492188 C 15.989803 15.348434 15.460091 16.011719 14 16.011719 C 12.614594 16.011719 11.988281 15.302225 11.988281 14.466797 C 11.988281 14.049083 12.140703 13.734298 12.460938 13.464844 C 12.78117 13.19539 13.295221 12.988281 14 12.988281 z M 11 19 A 1.0001 1.0001 0 0 0 10 20 L 10 39 A 1.0001 1.0001 0 0 0 11 40 L 17 40 A 1.0001 1.0001 0 0 0 18 39 L 18 33.134766 L 18 20 A 1.0001 1.0001 0 0 0 17 19 L 11 19 z M 20 19 A 1.0001 1.0001 0 0 0 19 20 L 19 39 A 1.0001 1.0001 0 0 0 20 40 L 26 40 A 1.0001 1.0001 0 0 0 27 39 L 27 29 C 27 28.170333 27.226394 27.345035 27.625 26.804688 C 28.023606 26.264339 28.526466 25.940057 29.482422 25.957031 C 30.468166 25.973981 30.989999 26.311669 31.384766 26.841797 C 31.779532 27.371924 32 28.166667 32 29 L 32 39 A 1.0001 1.0001 0 0 0 33 40 L 39 40 A 1.0001 1.0001 0 0 0 40 39 L 40 28.261719 C 40 25.300181 39.122788 22.95433 37.619141 21.367188 C 36.115493 19.780044 34.024172 19 31.8125 19 C 29.710483 19 28.110853 19.704889 27 20.423828 L 27 20 A 1.0001 1.0001 0 0 0 26 19 L 20 19 z M 12 21 L 16 21 L 16 33.134766 L 16 38 L 12 38 L 12 21 z M 21 21 L 25 21 L 25 22.560547 A 1.0001 1.0001 0 0 0 26.798828 23.162109 C 26.798828 23.162109 28.369194 21 31.8125 21 C 33.565828 21 35.069366 21.582581 36.167969 22.742188 C 37.266572 23.901794 38 25.688257 38 28.261719 L 38 38 L 34 38 L 34 29 C 34 27.833333 33.720468 26.627107 32.990234 25.646484 C 32.260001 24.665862 31.031834 23.983076 29.517578 23.957031 C 27.995534 23.930001 26.747519 24.626988 26.015625 25.619141 C 25.283731 26.611293 25 27.829667 25 29 L 25 38 L 21 38 L 21 21 z" /></svg>
        )
    }

    skype() {
        return (
            <svg fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="24px" height="24px"><path d="M 14.28125 0 C 6.417969 0 0 6.320313 0 14.09375 C 0 16.550781 0.6875 18.828125 1.8125 20.84375 C 1.539063 22.273438 1.375 23.746094 1.375 25.25 C 1.375 38.269531 12.074219 48.8125 25.25 48.8125 C 26.625 48.8125 27.964844 48.691406 29.28125 48.46875 C 31.214844 49.441406 33.402344 50 35.71875 50 C 43.582031 50 50 43.683594 50 35.90625 C 50 33.789063 49.480469 31.804688 48.625 30 C 48.949219 28.457031 49.15625 26.878906 49.15625 25.25 C 49.15625 12.238281 38.429688 1.6875 25.25 1.6875 C 23.988281 1.6875 22.746094 1.8125 21.53125 2 C 19.402344 0.753906 16.9375 0 14.28125 0 Z M 14.28125 2 C 16.691406 2 18.921875 2.667969 20.8125 3.84375 C 21.015625 3.976563 21.257813 4.03125 21.5 4 C 22.722656 3.792969 23.972656 3.6875 25.25 3.6875 C 37.363281 3.6875 47.15625 13.335938 47.15625 25.25 C 47.15625 26.839844 46.992188 28.382813 46.65625 29.875 C 46.59375 30.105469 46.617188 30.347656 46.71875 30.5625 C 47.539063 32.175781 48 33.972656 48 35.90625 C 48 42.589844 42.519531 48 35.71875 48 C 33.613281 48 31.628906 47.476563 29.90625 46.5625 C 29.714844 46.464844 29.496094 46.429688 29.28125 46.46875 C 27.976563 46.707031 26.621094 46.8125 25.25 46.8125 C 13.136719 46.8125 3.375 37.175781 3.375 25.25 C 3.375 23.765625 3.523438 22.308594 3.8125 20.90625 C 3.863281 20.660156 3.816406 20.402344 3.6875 20.1875 C 2.613281 18.390625 2 16.328125 2 14.09375 C 2 7.417969 7.484375 2 14.28125 2 Z M 25.09375 8.375 C 22.460938 8.375 20.09375 8.730469 18.0625 9.46875 C 18.054688 9.472656 18.039063 9.464844 18.03125 9.46875 C 15.980469 10.21875 14.308594 11.359375 13.15625 12.84375 C 11.992188 14.335938 11.375 16.121094 11.375 18.03125 C 11.375 20.007813 11.957031 21.785156 13.09375 23.1875 C 14.179688 24.523438 15.632813 25.570313 17.40625 26.3125 C 19.09375 27.019531 21.175781 27.613281 23.59375 28.125 C 25.324219 28.484375 26.726563 28.820313 27.71875 29.125 C 28.597656 29.394531 29.289063 29.796875 29.78125 30.25 C 30.179688 30.617188 30.34375 30.980469 30.34375 31.65625 C 30.34375 32.453125 30.019531 32.980469 29.0625 33.625 C 28.109375 34.269531 26.785156 34.65625 25.03125 34.65625 C 23.746094 34.65625 22.757813 34.453125 22.125 34.15625 C 21.417969 33.828125 20.890625 33.429688 20.5625 33 C 20.152344 32.46875 19.757813 31.769531 19.375 30.90625 C 18.96875 29.964844 18.441406 29.167969 17.75 28.59375 C 17.015625 27.984375 16.074219 27.6875 15.09375 27.6875 C 13.933594 27.6875 12.847656 28.058594 12.03125 28.8125 C 11.226563 29.5625 10.75 30.601563 10.75 31.6875 C 10.75 33.261719 11.339844 34.839844 12.40625 36.34375 C 13.457031 37.84375 14.863281 39.050781 16.53125 39.9375 C 18.871094 41.164063 21.78125 41.75 25.1875 41.75 C 28.027344 41.75 30.5625 41.320313 32.71875 40.4375 C 34.886719 39.550781 36.625 38.28125 37.8125 36.625 C 38.992188 34.976563 39.589844 33.050781 39.59375 31 C 39.59375 29.308594 39.253906 27.796875 38.53125 26.53125 C 37.832031 25.308594 36.84375 24.285156 35.625 23.5 C 34.457031 22.75 33.058594 22.128906 31.46875 21.625 C 29.933594 21.140625 28.210938 20.679688 26.34375 20.28125 C 26.328125 20.277344 26.328125 20.285156 26.3125 20.28125 C 24.875 19.953125 23.820313 19.695313 23.21875 19.53125 C 22.667969 19.378906 22.082031 19.175781 21.53125 18.90625 C 21.050781 18.667969 20.722656 18.386719 20.5 18.125 C 20.332031 17.921875 20.28125 17.789063 20.28125 17.46875 C 20.28125 16.996094 20.460938 16.632813 21.25 16.125 C 22.023438 15.621094 23.144531 15.34375 24.65625 15.34375 C 26.308594 15.34375 27.40625 15.648438 27.875 16 C 28.527344 16.484375 29.140625 17.21875 29.65625 18.1875 C 29.667969 18.199219 29.675781 18.207031 29.6875 18.21875 C 30.210938 19.105469 30.691406 19.761719 31.25 20.25 C 31.945313 20.851563 32.867188 21.09375 33.875 21.09375 C 35.039063 21.09375 36.132813 20.667969 36.9375 19.84375 C 37.714844 19.050781 38.1875 18.035156 38.1875 16.96875 C 38.1875 15.941406 37.882813 14.894531 37.34375 13.90625 C 36.789063 12.890625 35.9375 11.96875 34.84375 11.125 C 33.726563 10.261719 32.347656 9.582031 30.75 9.09375 C 29.121094 8.59375 27.214844 8.375 25.09375 8.375 Z M 25.09375 10.375 C 27.066406 10.375 28.78125 10.605469 30.15625 11.03125 C 31.570313 11.464844 32.746094 12.039063 33.625 12.71875 C 34.550781 13.433594 35.203125 14.164063 35.59375 14.875 C 36.003906 15.625 36.1875 16.324219 36.1875 16.96875 C 36.1875 17.515625 36.003906 17.953125 35.53125 18.4375 C 35.085938 18.898438 34.574219 19.09375 33.875 19.09375 C 33.1875 19.09375 32.789063 18.945313 32.5625 18.75 C 32.273438 18.5 31.878906 17.988281 31.4375 17.25 C 31.425781 17.226563 31.417969 17.210938 31.40625 17.1875 C 30.785156 16.042969 30.011719 15.089844 29.09375 14.40625 C 28.027344 13.605469 26.53125 13.34375 24.65625 13.34375 C 22.882813 13.34375 21.363281 13.6875 20.15625 14.46875 C 19.03125 15.195313 18.28125 16.257813 18.28125 17.46875 C 18.28125 18.175781 18.523438 18.867188 18.96875 19.40625 C 19.40625 19.921875 19.976563 20.351563 20.65625 20.6875 C 21.3125 21.011719 22 21.28125 22.6875 21.46875 C 23.351563 21.648438 24.433594 21.914063 25.90625 22.25 C 27.734375 22.636719 29.40625 23.070313 30.875 23.53125 C 32.332031 23.996094 33.582031 24.558594 34.5625 25.1875 C 35.53125 25.8125 36.277344 26.59375 36.8125 27.53125 C 37.324219 28.429688 37.59375 29.574219 37.59375 31 C 37.59375 32.667969 37.132813 34.148438 36.1875 35.46875 C 35.253906 36.773438 33.859375 37.820313 31.96875 38.59375 C 30.113281 39.355469 27.824219 39.75 25.1875 39.75 C 22.015625 39.75 19.429688 39.214844 17.46875 38.1875 C 16.058594 37.4375 14.929688 36.425781 14.0625 35.1875 C 14.050781 35.1875 14.042969 35.1875 14.03125 35.1875 C 13.144531 33.933594 12.75 32.765625 12.75 31.6875 C 12.75 31.121094 12.949219 30.707031 13.40625 30.28125 C 13.847656 29.875 14.339844 29.6875 15.09375 29.6875 C 15.683594 29.6875 16.101563 29.816406 16.46875 30.125 C 16.835938 30.429688 17.214844 30.949219 17.53125 31.6875 C 17.542969 31.699219 17.550781 31.707031 17.5625 31.71875 C 17.992188 32.691406 18.464844 33.523438 19 34.21875 C 19.5625 34.953125 20.335938 35.53125 21.28125 35.96875 C 22.308594 36.449219 23.558594 36.65625 25.03125 36.65625 C 27.0625 36.65625 28.808594 36.238281 30.1875 35.3125 C 31.511719 34.421875 32.34375 33.113281 32.34375 31.65625 C 32.34375 30.546875 31.910156 29.507813 31.125 28.78125 C 30.367188 28.082031 29.421875 27.558594 28.3125 27.21875 C 27.222656 26.882813 25.765625 26.554688 24 26.1875 C 21.667969 25.695313 19.710938 25.105469 18.1875 24.46875 C 16.667969 23.832031 15.507813 22.957031 14.65625 21.90625 C 13.824219 20.878906 13.375 19.636719 13.375 18.03125 C 13.375 16.527344 13.816406 15.21875 14.71875 14.0625 C 14.730469 14.0625 14.738281 14.0625 14.75 14.0625 C 15.632813 12.921875 16.929688 11.996094 18.71875 11.34375 C 20.476563 10.699219 22.628906 10.375 25.09375 10.375 Z" /></svg>
        )

    }
    render() {
        const { classes, whiteFont } = this.props;

        const aClasses = classNames({
            [classes.a]: true,
            [classes.footerWhiteFont]: whiteFont
        });

        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/provider/list/${this.state.clickedServiceId}`,
                state: {
                    serviceId: this.state.clickedServiceId,
                    providerData: this.state.providerData
                }
            });
        }
        return (
            <div>
                <footer id="colophon" className="site-footer clearfix">
                    <div
                        id="quaternary"
                        className="sidebar-container "
                        role="complementary"
                    >
                        {/* <div style={{ position: "absolute", width: "100%" }}>
                            <img
                                className="full-width"
                                width={'100%'}
                                height={'100%'}
                                aria-label="banner-img"
                                src={require("../../assets/images/rectangle2.jpg")}
                            />
		
			
                        </div> */}
                        <div className="sidebar-inner">
                            <div className="widget-area clearfix">
                                <div
                                    id="azh_widget-2"
                                    className="widget widget_azh_widget"
                                    style={{ paddingTop: 150 }}>
                                    <div className="bg_postion">
                                        <div className="postion_div">
                                            <img
                                                style={{ objectFit: "contain" }}
                                                className="full-width"
                                                width={'40%'}
                                                height={'40%'}
                                                aria-label="banner-img"
                                                src={require("../../assets/images/Subtract.png")}
                                            /></div>
                                        <div data-section="section">

                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-md-6 col-lg-3  foot-logo">
                                                        {' '}
                                                        <img
                                                            src={this.props.settings.constants.LOGO != "" ? this.props.settings.constants.LOGO : logo}
                                                            width="50px"
                                                            height="auto"

                                                        />
                                                        <p className="footersubheading" style={{ opacity: 1 }}>
                                                            {
                                                                this.props.constants
                                                                    .about_us
                                                            }
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6 col-lg-3  foot-social">
                                                        <h4 className="footerheading">
                                                            <FormattedMessage
                                                                id="Follow Us on Social”"
                                                                defaultMessage="Follow Us on Social"
                                                            />
                                                        </h4>
                                                        <p className="foot_text">
                                                            {/* join the thousands of other there are many variations of passages of Lore ipsum available  */}
                                                        </p>
                                                        <ul>
                                                            <li>
                                                                {this.props
                                                                    .constants
                                                                    .facebook && (
                                                                        <a
                                                                            href={
                                                                                this
                                                                                    .props
                                                                                    .constants
                                                                                    .facebook
                                                                            }
                                                                        >
                                                                            <span
                                                                                style={{ "color": "#37d67a" }}>

                                                                                <img src={fb} />

                                                                            </span>
                                                                        </a>
                                                                    )}
                                                            </li>


                                                            <li>
                                                                {this.props
                                                                    .constants
                                                                    .google && (
                                                                        <a
                                                                            href={
                                                                                this
                                                                                    .props
                                                                                    .constants
                                                                                    .google
                                                                            }
                                                                        >
                                                                            <i
                                                                                className="fa fa-google-plus"
                                                                                aria-hidden="true"
                                                                            />
                                                                        </a>
                                                                    )}
                                                            </li>
                                                            <li>
                                                                {this.props
                                                                    .constants
                                                                    .instagram && (
                                                                        <a
                                                                            href="https://twitter.com/ezprohome"
                                                                        >
                                                                            <img src={logowhite} className="tuter" />
                                                                        </a>
                                                                    )}
                                                            </li>
                                                            <li>
                                                                {this.props
                                                                    .constants
                                                                    .instagram && (
                                                                        <a
                                                                            href="https://www.instagram.com/ezprohome/"
                                                                        >
                                                                            <img src={insta} style={{
                                                                                outline: '1'
                                                                            }} className="tuter" />
                                                                        </a>
                                                                    )}
                                                            </li>

                                                            <li>
                                                                {this.props
                                                                    .constants
                                                                    .linkedin && (
                                                                        <a
                                                                            href={
                                                                                this
                                                                                    .props
                                                                                    .constants
                                                                                    .linkedin
                                                                            }
                                                                        >
                                                                            {/* {this.linkedin()} */}
                                                                            <img src={link} className="tuter" style={{ aspectRatio: "3/4" }} />
                                                                        </a>
                                                                    )}
                                                            </li>
                                                            {/* <li>
                                                            {this.props
                                                                .constants
                                                                .youtube && (
                                                                    <a
                                                                        href={
                                                                            this
                                                                                .props
                                                                                .constants
                                                                                .youtube
                                                                        }
                                                                    >
                                                                        <i
                                                                            className="fa fa-youtube"
                                                                            aria-hidden="true"
                                                                        />
                                                                    </a>
                                                                )}
                                                        </li> */}
                                                            {/* <li>
                                                            {this.props
                                                                .constants
                                                                .skypeid && (
                                                                    <a
                                                                        href={
                                                                            `skype:` +
                                                                            this
                                                                                .props
                                                                                .constants
                                                                                .skypeid
                                                                        }
                                                                    >
									{ this.skype() }
                                                                    </a>
                                                                )}
                                                        </li> */}
                                                        </ul>
                                                    </div>

                                                    <div className="col-md-6 col-lg-3 support">
                                                        <h4 className="footerheading">
                                                            <FormattedMessage
                                                                id="support"
                                                                defaultMessage="Support"
                                                            />
                                                            {' '}&amp;{' '}
                                                            <FormattedMessage
                                                                id="help"
                                                                defaultMessage="Help"
                                                            />
                                                        </h4>
                                                        <div className="footer-menu-ul">
                                                            {this.props.cmsLinks
                                                                .length > 0 &&
                                                                this.props.cmsLinks.map(
                                                                    (
                                                                        link,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <p
                                                                                key={
                                                                                    index
                                                                                }

                                                                            >
                                                                                <Link
                                                                                    to={`/page/${link.slug}`}
                                                                                    className="footersubheading"
                                                                                >
                                                                                    <FormattedMessage
                                                                                        id={
                                                                                            link.title
                                                                                        }
                                                                                        defaultMessage={
                                                                                            link.title
                                                                                        }
                                                                                    />
                                                                                </Link>
                                                                            </p>
                                                                        );
                                                                    }
                                                                )}

                                                            <p
                                                                key={
                                                                    4
                                                                }

                                                            >
                                                                <Link
                                                                    to={`/contact-us`}
                                                                    className="footersubheading"
                                                                >
                                                                    Contact Us
                                                                </Link>
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6 col-lg-3 popularServices">
                                                        <h4 className="footerheading">
                                                            <FormattedMessage
                                                                id="popularServices"
                                                                defaultMessage="Popular Services"
                                                            />
                                                        </h4>
                                                        <div>
                                                            {this.state.services
                                                                .length > 0 &&
                                                                this.state.services.map(
                                                                    (
                                                                        service,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <p
                                                                                key={
                                                                                    index
                                                                                }
                                                                                className="footersubheading"
                                                                            >
                                                                                <a
                                                                                    style={{
                                                                                        cursor:
                                                                                            'pointer'
                                                                                    }}
                                                                                    // onClick={() =>
                                                                                    //     this.redirectLink(
                                                                                    //         service.slug
                                                                                    //     )
                                                                                    // } 

                                                                                    onClick={() => this.alltask(service)}
                                                                                >
                                                                                    {
                                                                                        service.heading
                                                                                    }
                                                                                </a>
                                                                            </p>
                                                                        );
                                                                    }
                                                                )}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div data-section="section" className="foot-sec3">
                                            <div className="container">
                                                <div className="row d-flex align-items-end">
                                                    <div className="col-md-6 col-lg-3">
                                                        <div classnames="responsive-payment-option">
                                                            <h4 className="footerheading">
                                                                <FormattedMessage
                                                                    id="paymentOptions"
                                                                    defaultMessage="Payment Options"
                                                                />
                                                            </h4>
                                                            <div className="hasimg">
                                                                <div class="hasimglist">
                                                                    <a href="#"><img src={pay5} /></a>
                                                                    {/* <a href="#"><img src={maestro} /></a> */}
                                                                    <a href="#"><img src={pay4} /></a>
                                                                </div>
                                                                <div class="hasimglist">
                                                                    {/* 
                                                                    <a href="#"><img src={pay1} /></a> */}
                                                                    <a href="#"><img src={pay6} /></a>
                                                                    <a href="#"><img src={pay7} /></a>
                                                                </div>{' '}
                                                                {/* <img
                                                            src="https://www.merchantequip.com/image/?logos=v|m|a|d&height=64" alt="Merchant Equipment Store Credit Card Logos" /> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-3 icon_list">
                                                        {/* <div classnames="responsive-footer-address">
                                                        <LocationOn color="#ffffff" style={{ color: "#ffffff" }} />
                                                        <span className="footersubheading1">
                                                            {
                                                                this.props.constants
                                                                    .address_line1
                                                            }
                                                        ,{' '}
                                                            {
                                                                this.props.constants
                                                                    .address_line2
                                                            }
                                                        </span>
                                                    </div> */}
                                                    </div>




                                                    <div className="col-md-6 col-lg-3 icon_list">
                                                        <div className="responsive-footer-phone">
                                                            <Call color="#ffffff" style={{ color: "#ffffff" }} />


                                                            <span className="footersubheading1">
                                                                {/* {
                                                                    this.props
                                                                        .constants
                                                                        .phone_number
                                                                } */}
                                                                xxx-xxx-xxxx
                                                            </span>{' '}

                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-3 icon_list">
                                                        <div className="responsive-footer-email">
                                                            <Email style={{ color: "#ffffff" }} />
                                                            <span className="footersubheading1">


                                                                {/* {
                                                                    this.props
                                                                        .constants
                                                                        .admin_email
                                                                } */}
                                                                admin@ezprohome.com
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </footer>

                <Dialog
                    fullWidth={true}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="service-modal"
                    open={this.state.showServiceDialog}
                    onClose={this.handleCloseServiceDialog}
                    aria-labelledby="form-dialog-title"
                >


                    <div className="modal-header dir-pop-head">
                        <div className="heding1">
                            <h4>What would you like to do with  service</h4>
                        </div>
                        <Clear className="close_icon" style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                            this.handleCloseServiceDialog()
                        }} />

                    </div>

                    <div>

                    </div>


                    {/* {this.state.showBookButton && <button style={{
                        alignSelf: 'center', display: "inline-flex",
                        position: "absolute", bottom: 10, justifyContent: "center",
                        backgroundColor: this.props.colors.SECONDARY.HEX, padding: 15, borderRadius: 8,
                        color: "#ffffff", borderWidth: 0, width: "90%"
                    }}
                        disabled={this.state.showBookButton ? false : true}
                        onClick={this.onBookNow}
                    >BOOK NOW</button>} */}
                    {/* 
                    {this.state.newServiceDialog &&
                        <NewServiceSuggestionDialog
                            closeDialog={this.handleCloseSuggestionDialog}
                        />} */}
                    <DialogContent>
                        no
                    </DialogContent>

                </Dialog>


                <section className="copy">
                    <div className="container">
                        <p>
                            Copyright &copy; {1900 + new Date().getYear()}{' '}
                            <a
                                href="/"
                                className={aClasses}
                                target="_blank"
                            >
                                {' '}
                                {this.props.constants.companyName}
                            </a>
                            .&nbsp;All rights reserved.{' '}
                        </p>
                    </div>
                </section>

            </div >
        );
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
    whiteFont: PropTypes.bool
};
const mapStateToProps = ({ settings }) => {
    return { cmsLinks: settings.cmsLinks, constants: settings.constants, settings: settings };
};

const composedComponent = compose(
    withTheme(),
    connect(
        mapStateToProps,
        actions
    ),
    withStyles(footerStyle)
);
export default composedComponent(withUser(withRouter(Footer)));



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx